import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalKey } from '@frontend-workspace/shared/src/lib/types/modal-key';

@Component({
  selector: 'fip-image-modal',
  templateUrl: './image.modal.html',
  styleUrls: ['./image.modal.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ImageModalComponent {
  data = inject<{
    imageUrl: string;
  }>(MAT_DIALOG_DATA);

  readonly modalKey: ModalKey = 'image';
}
